import { Component, OnInit, ViewChild } from '@angular/core';
import { ImageDto } from '../typewriter/output/ImageDto';
import { ImageService } from '../typewriter/output/ImageController';
import { FeedService } from '../typewriter/output/FeedController';
import { FeedDto } from '../typewriter/output/FeedDto';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  title = 'MotoRidePhoto';
  carouselImages: ImageDto[];
  feedItems: FeedDto[];
  carousel: Observable<any>;
  news: Observable<any>;
  slideConfig = {
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 5,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
  };

  constructor(
    private imageService: ImageService,
    private feedService: FeedService
  ) { }

  ngOnInit(): void {
    this.carousel = Observable.fromPromise(this.imageService.forCarousel(20)
      .then(result => {
        this.carouselImages = result;
      }));
    this.news = Observable.fromPromise(this.feedService.getNews(3)
      .then(result => {
        this.feedItems = result;
      }));
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts